import { useBoundStore } from '@Store/index.ts';
import { OnboardingFormFields } from '@Types/index.ts';
import type { IHomeAddressForm } from '@Types/homeAddress';

export const resolveStateValue = (payload: IHomeAddressForm): string | null => {
  const country = payload[OnboardingFormFields.COUNTRY];
  if (country && !country.subDivisions?.length) {
    return null;
  }
  return payload[OnboardingFormFields.STATE]?.value || null;
};

export const syncSliceWithForm = (formData: IHomeAddressForm) => {
  const { getCustomerData, setCustomerData } = useBoundStore.getState();
  const customerDataToUpdate = getCustomerData();
  setCustomerData({
    ...customerDataToUpdate,
    customerData: {
      ...customerDataToUpdate.customerData,
      customerAddressData: {
        ...customerDataToUpdate.customerData.customerAddressData,
        line1: formData[OnboardingFormFields.LINE1],
        line2: formData[OnboardingFormFields.APARTMENT],
        state: resolveStateValue(formData) ?? '',
        city: formData[OnboardingFormFields.CITY],
        postalCode: formData[OnboardingFormFields.ZIP],
        country: formData[OnboardingFormFields.COUNTRY]?.code,
      },
    },
  });
};
